import Head from 'next/head';

const DocumentTitle = ({ children }: { children?: string }) => (
  <Head>
    <title key="document-title">{`${children}${
      children ? ' - ' : ''
    }Powered by Foam`}</title>
  </Head>
);

export default DocumentTitle;
